


/*
FrFr FRIENDLY FRAMEWORK
frfr-lib-document-utils
Version ID: 1a 2023-10-16r1
by 
// Please describe here if you customized this file
*/


// frfr-lib-document-utils

/*
DOKUMENTACIJA:

TODO:
- Mora da se osposobi da barata i sa drugim tipovima docuemnt entiteta osim type: "TABULAR_DOCUMENT".

*/


//
/*
const _array_of_objects_to_document_lib_entity = (arr, tabulardoc_key_column_name) => {
  const _document_lib_entity = {};
  console.log('+++++ tabulardoc_key_column_name', tabulardoc_key_column_name, 'arr', arr);
  arr.forEach((row) => {
    if (row && typeof row[tabulardoc_key_column_name] === 'string') {
      // row Object ima polje sa obaveznim kljucem
      const row_key = row[tabulardoc_key_column_name];
      _document_lib_entity[row_key] = { ...row };
    }
  });
  return _document_lib_entity;
};
*/


// 
export const tabular_document_utils_entity_create = (lib_entity_key, tabulardoc_column_names, tabulardoc_key_column_name, tabulardoc_rows, lib_note) => {
  // type tabular_document
  // tabular document is object converted from CSV.
  // like CSV has column names (from first CSV row) and rows...
  //.
  const _prepared_tabulardoc_rows = tabulardoc_rows.map((row) => {
    const prepared_row = {};
    tabulardoc_column_names.forEach((name) => {
      prepared_row[name] = row[name]; // include only usable columns
    });
    return prepared_row;
  });
  const new_tabular_document = {
    lib_entity_key,
    lib_entity_type: "TABULAR_DOCUMENT", // CSV DOCUMENT
    tabulardoc_key_column_name,
    tabulardoc_column_names,
    tabulardoc_rows: _prepared_tabulardoc_rows,
    lib_note,
  };
  return new_tabular_document;
};


//
export const lib_document_utils_tabular_document_to_optimized_document = (lib_obj) => {
  // konvertuje tabulardoc_rows koji su Array u _optimized_lib_entity koji je Object za brzi pristup redovima putem named key umesto indexa.
  // ova funkcija se koristi od strane "cache_utils" metoda koji kesiraju bazu lib_document
  // type tabular_document 
  const {
    tabulardoc_rows,
    tabulardoc_key_column_name
  } = lib_obj;
  const _optimized_lib_entity = {};
  if (Array.isArray(tabulardoc_rows) && typeof tabulardoc_key_column_name === 'string') {
    console.log('+++++ tabulardoc_key_column_name', tabulardoc_key_column_name);
    // console.log('+++++ tabulardoc_rows', tabulardoc_rows);
    tabulardoc_rows.forEach((row) => {
      if (row && typeof row[tabulardoc_key_column_name] === 'string') {
        // row Object ima polje sa obaveznim kljucem
        const row_key = row[tabulardoc_key_column_name];
        _optimized_lib_entity[row_key] = { ...row };
      }
    });
  }
  return _optimized_lib_entity;
};


// OLD
const _document_lib_entity_to_array_of_objects = (lib_obj) => {
  // convert document to Array of Objects for table display
  const _document_table_rows_data = [];
  Object.keys(lib_obj).forEach((row_key) => {
    const table_row_obj = lib_obj[row_key];
    _document_table_rows_data.push(table_row_obj);
  });
  return _document_table_rows_data;
};


// OLD
const _array_of_objects_to_optimized_obj = (arr, tabulardoc_key_column_name) => {
  const _document_lib_entity = {};
  console.log('+++++ tabulardoc_key_column_name', tabulardoc_key_column_name, 'arr', arr);
  arr.forEach((row) => {
    if (row && typeof row[tabulardoc_key_column_name] === 'string') {
      // row Object ima polje sa obaveznim kljucem
      const row_key = row[tabulardoc_key_column_name];
      _document_lib_entity[row_key] = { ...row };
    }
  });
  return _document_lib_entity;
};